import { Typography } from "antd";
import TopBar from "./TopBar";

const { Title, Text } = Typography;

const DataHistoryPageHeader = ({ screens, onBack }) => (
  <div className="relative flex flex-col items-center mb-8 pt-5 px-4 md:px-0">
    <div className="self-start md:absolute md:left-0 md:top-5 md:self-auto mb-4 md:mb-0">
      <TopBar onBack={onBack} />
    </div>
    <Title
      level={2}
      className="!text-white font-bold !mb-2 text-center"
       style={{ fontSize: screens?.xs ? "1.5rem" : "2rem", lineHeight: 1.2 }}
    >
      <span className="bg-gradient-to-r from-purple-300 via-violet-400 to-purple-500 bg-clip-text text-transparent">AI Insight </span>Config Layer
    </Title>
    <Text type="secondary" className="!text-white !text-base md:!text-lg !mt-2 md:!mt-4 leading-relaxed text-center max-w-3xl">
      Manage your uploaded files and configure analytics. Review your dataset structure and configure analytics parameters for optimal model performance.
    </Text>
  </div>
);

export default DataHistoryPageHeader;